import React from 'react'
import { Button, Icon } from 'semantic-ui-react'

interface ButtonProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'color'> {
  isDefault: boolean
  handleClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  style?: { [key: string]: any }
}

export const RevertToDefaultButton = ({
  handleClick,
  isDefault,
  style = {},
  ...rest
}: ButtonProps) => {
  const mergedStyle = {
    ...style,
    fontSize: '.92857143em',
    marginBottom: '0.285714rem',
    fontWeight: 600,
  }
  if (isDefault === true) {
    return <span style={{ ...mergedStyle, color: '#777' }}>(Jane default)</span>
  }
  return (
    <Button
      type="button"
      basic
      color="blue"
      className="link"
      style={mergedStyle}
      onClick={handleClick}
      {...rest}
    >
      <Icon name="undo alternate" />
      <span>Revert to default</span>
    </Button>
  )
}
